<template>
  <div>
    <div style="margin-bottom: 15px">
      <span style="margin-left: 12px">名称、地址、编码：</span>
      <a-input allow-clear v-model="keyword" style="width: 10%"/>
      <a-button type="primary" icon="search" style="margin-left: 15px" @click="handleSearch">查询</a-button>
    </div>
    <a-divider />
    <div style="margin-bottom: 15px">
      <a-button :disabled="true" icon="plus" type="primary" style="margin-left: 15px" @click="handleSearch">新增</a-button>
    </div>

    <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="pagination"
        @change="handleTableChange"
        size="middle"
        :loading="loading"
        rowKey="id"
        bordered>
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <template slot="qrcode" slot-scope="text, record">
        <a-button style="padding: 0 3px;" type="link" @click="$refs.qrCodeModal.showModal(record.id, record.name, 'qrcode')">
          <span style="margin-left: 2px">查看</span>
        </a-button>
      </template>
      <template slot="miniCode" slot-scope="text, record">
        <a-button style="padding: 0 3px;" type="link" @click="$refs.qrCodeModal.showModal(record.id, record.name)">
          <span style="margin-left: 2px">查看</span>
        </a-button>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-button :disabled="true" style="padding: 0 3px;" type="link">
          <a-icon type="edit" /><span style="margin-left: 2px">编辑</span>
        </a-button>
        <a-divider type="vertical" />
        <a-button style="padding: 0 3px;" type="link" @click="$refs.priceConfig.showModal(record)">
          <a-icon type="account-book" /><span style="margin-left: 2px">价格配置</span>
        </a-button>
        <br/>
        <a-button style="padding: 0 3px;" type="link" @click="$refs.gradeManage.showModal(record)">
          <a-icon type="calculator" /><span style="margin-left: 2px">年级/班级管理</span>
        </a-button>
      </template>
    </a-table>
    <qr-code-modal ref="qrCodeModal" />
    <price-config ref="priceConfig" />
    <grade-manage ref="gradeManage" />
  </div>
</template>

<script>
import bizOrgService from '@/service/bizOrg'
import QrCodeModal from "@/pages/BizOrgManage/QrCodeModal.vue";
import PriceConfig from "@/pages/BizOrgManage/PriceConfig.vue";
import GradeManage from "@/pages/BizOrgManage/GradeManage.vue";

export default {
  name: "EmpList",
  components: {QrCodeModal, PriceConfig, GradeManage},
  data() {
    return {
      columns: [
        {title: '#', scopedSlots: {customRender: 'serial'}, align: 'center'},
        {title: '名称', dataIndex: 'name', align: 'center'},
        {title: '编码', dataIndex: 'code', align: 'center'},
        {title: '地址', dataIndex: 'address', align: 'center'},
        {title: '店长', dataIndex: 'manager', align: 'center'},
        {title: '客服电话', dataIndex: 'kfMobile', align: 'center'},
        {title: '小程序码', align: 'center', scopedSlots: { customRender: 'miniCode'}},
        {title: '公众号二维码', align: 'center', scopedSlots: { customRender: 'qrcode'}},
        {title: '创建时间', dataIndex: 'created', align: 'center'},
        {title: '操作', dataIndex: 'action', scopedSlots: {customRender: 'action'}, align: 'center'}
      ],
      rows: [],
      pagination: {},

      keyword: '',

      loading: false
    };
  },
  mounted() {
    let params = {
      current: 1,
      size: 10,
    }
    this.fetch(params)
  },
  methods: {
    handleTableChange(pagination) {
      this.fetch(pagination)
    },
    handleSearch() {
      this.fetch()
    },
    fetch(page) {
      let params = {
        current: page ? page.current : 1,
        size: page ? page.size : 10,
        keyword: this.keyword,
      }
      this.loading = true
      bizOrgService.queryPage(params).then((res) => {
        const pagination = {...this.pagination};
        this.rows = res.data.records
        pagination.current = res.data.current
        pagination.total = res.data.total
        pagination.size = res.data.size + ''
        pagination.showTotal = (total, range) => {
          return `${range[0]}-${range[1]} 总计 ${total} 条`
        }
        this.pagination = pagination
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
